import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { text } from 'framer-motion/client';
import iconWA from '../assets/whatsapp.svg'
import iconPh from '../assets/phone.svg'

const Contactanos = () => {
    return ( 
        <section style={{textAlign: 'center'}}>
            <ConatcanosH2>Contáctanos mediante</ConatcanosH2>
            <p>Contacto con Richard Alvarez Rodríguez</p>
            <ButtonContainer >
              <motion.div
               whileHover={{ scale: 1.1 }}
               whileTap={{ scale: 0.95 }}>
                <ButtonWhatsApp type='Button'
                onClick={() =>
                    window.open("https://api.whatsapp.com/send?phone=524773059542", "_blank")
                  }><img src={iconWA} alt='WhatsappIcon' /> WhatsApp</ButtonWhatsApp>
              </motion.div>
              <motion.div
               whileHover={{ scale: 1.1 }}
               whileTap={{ scale: 0.95 }}>
                <ButtonCall type='Button'onClick={() =>
                    window.open("tel:4773059542", "_self")
                    }
                ><img src={iconPh} alt='phoneIcon' /><p>Telefono</p></ButtonCall>
                </motion.div>
            </ButtonContainer>
        </section>
     );
}
const ConatcanosH2 = styled.h2 `
  text-align: center;
  margin: 10px;
`
const ButtonContainer = styled.div `
  display: flex;
  justify-content: center;

  button {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`
const ButtonWhatsApp = styled.button`
  padding: 15px 25px;
  font-size: 16px;
  margin: 10px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  background-color: #25D366; 
  color: white;
  text-align: center;
  img {
    filter: invert(100%);
    width: 80px;
  }
  &:hover {
    background-color: #1DA853; 
  }
`;

const ButtonCall = styled.button`
  padding: 15px 25px;
  font-size: 16px;
  margin: 10px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  background-color: #ff0000; 
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  
  img {
    filter: invert(100%);
    width: 80px;
  }
  &:hover {
    background-color: #cc0000; 
  }
`;
export default Contactanos;